/**
 * Format timestamp as "Jan 25, 2.30 PM" (using period instead of colon
 * for filename safety).
 */
const formatTimestamp = (timestamp: number): string => {
  const date = new Date(timestamp);
  const formatted = date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  // Replace colon with period for filename compatibility
  return formatted.replace(':', '.');
};

export default formatTimestamp;
